import { refs, domReady } from '../modules/utils.js';

class ScrollTop extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

customElements.define('scroll-top', ScrollTop);
